import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import { CheckboxField } from 'components/forms'
import { Svg } from 'components/util'
import styles from './_workoutForm.css'

export function ShareContent ({ service, selected, children }) {
  return (
    <div className={classnames(styles[service], {
      [styles.selected]: selected,
    })}>
      <Svg name={service} className={styles.shareIcon} />
      {children}
    </div>
  )
}

ShareContent.propTypes = {
  service: PropTypes.string,
  selected: PropTypes.bool,
  children: PropTypes.node,
}

export function Social ({ className }) {
  return (
    <Row className={className}>
      <Col xs={12} sm={6}>
        <CheckboxField
          button
          name='shareOnFacebook'
          labelComponent={(
            <ShareContent service='facebook'>
              <FormattedMessage
                id='workouts.create.share_on_facebook'
                defaultMessage='Share on Facebook'
              />
            </ShareContent>
          )}
        />
      </Col>
      <Col xs={12} sm={6}>
        <CheckboxField
          button
          name='shareOnTwitter'
          labelComponent={(
            <ShareContent service='twitter'>
              <FormattedMessage
                id='workouts.create.share_on_twitter'
                defaultMessage='Share on Twitter'
              />
            </ShareContent>
          )}
        />
      </Col>
    </Row>
  )
}

Social.propTypes = {
  className: PropTypes.string,
}

export default Social
